module.exports = __webpack_public_path__ + "img/wmdmb.b25d29a6.png";